import axios from "axios";
import { FILM_API_BASE } from "@/contract/constants";

function assertOk(data, context) {
  if (!data || data.code !== 200) {
    const msg = (data && data.message) || `${context} failed`;
    throw new Error(msg);
  }
}

export async function uploadMetadataImage(file) {
  const form = new FormData();
  form.append("image", file);
  const { data } = await axios.post(`${FILM_API_BASE}/upload-metadata`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  assertOk(data, "upload-metadata");
  if (!data.image_url) throw new Error("upload-metadata: missing image_url");
  return data.image_url;
}

export async function createMetadataJson(payload) {
  const form = new FormData();
  form.append("project_name", payload.project_name);
  form.append("description", payload.description);
  form.append("issuer", payload.issuer);
  form.append("image_url", payload.image_url);
  const { data } = await axios.post(`${FILM_API_BASE}/create-json`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  assertOk(data, "create-json");
  if (!data.token_uri) throw new Error("create-json: missing token_uri");
  return data.token_uri;
}

export async function fetchMetadataFromUri(tokenUri) {
  const { data } = await axios.get(tokenUri, { timeout: 15000 });
  return data;
}

function issuerFromAttributes(attributes) {
  if (!Array.isArray(attributes)) return "";
  const hit = attributes.find(
    (a) =>
      a &&
      String(a.trait_type || a.traitType || "").toLowerCase() === "issuer"
  );
  return hit ? String(hit.value ?? "").trim() : "";
}

/** 从 cardUri JSON 解析 UI 字段；NFT 代理地址供认购用 */
export function resolveNftContractFromMeta(meta) {
  if (!meta || typeof meta !== "object") return "";
  const addr =
    meta.card_address ||
    meta.cardAddress ||
    meta.proxy_address ||
    meta.proxyAddress ||
    meta.nft_contract ||
    meta.contract_address ||
    "";
  return /^0x[a-fA-F0-9]{40}$/.test(addr) ? addr : "";
}

export async function fetchCardMetadata(cardUri) {
  const raw = await fetchMetadataFromUri(cardUri);
  if (!raw || typeof raw !== "object") {
    throw new Error("Invalid metadata JSON");
  }
  const name = raw.project_name || raw.name || "";
  const issuer =
    raw.issuer ||
    raw.creator ||
    issuerFromAttributes(raw.attributes) ||
    "";
  return {
    ...raw,
    name,
    project_name: name,
    description: raw.description || "",
    issuer,
    imageUrl: raw.image || raw.image_url || "",
    english: raw.english || raw.tagline || "",
    name_en: raw.name_en,
    about2: raw.about2 || raw.disclaimer || "",
    poster_bottom: raw.poster_bottom,
  };
}
